// extracted by mini-css-extract-plugin
export default {"container":"theme_container__1kxnM","logoContainer":"theme_logoContainer__5iw-W","inner":"theme_inner__s6Lvd","information":"theme_information__zM2VM"};